export function requireElement<T extends HTMLElement = HTMLElement>(
  id: string,
): T {
  const el = document.getElementById(id);
  if (!el) {
    throw new Error(`[boot] required DOM element #${id} not found`);
  }
  return el as T;
}
